"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Creative_1 = __importDefault(require("../entity/Creative"));
/**
 * デフォルトで生成されるJSON
 */
const defaultValue = {
    fileUrl: 'https://usercontent-hugot-dev2.pbcd.net/files/f45ecce119fd4331950669b16f9b1c161c8b511620be4406a3ab3bcb4a723925149f07707c434cff9a13c2ce3d6d4ccb',
    height: 360,
    industry: [],
    thumbnailUrl: 'https://usercontent-hugot-dev2.pbcd.net/files/21f61fdecb95431f911c80e640f20f49fcfd5fca349947238dc399718187493f838477ab75ad4793bb2941c889eaea15',
    width: 640,
    id: '01E1JVB4P8XZ',
    contentType: 'video/mp4',
    fileSize: 791006,
    fileUpdatedAt: '2020-02-21T03:05:27.000Z',
    optimizerId: 20251,
    organizationId: 20250,
    scope: 1,
    service: 'ad',
    tag: ['ゲーム', '漫画'],
    organizationTag: ['A社ゲーム'],
    placement: 'facebook',
    aspectRatio: '16:9',
    duration: 14,
    composition: [],
    optimizerProfileImageUrl: 'https://cdn-dev.kaizenplatform.net/dev2/users/000/020/251/3e10efcbdde8a5055d7fdfe4ed700116ecac45e7.jpg',
    favorite: 0,
};
exports.generateCreativeEntity = (json = defaultValue) => Creative_1.default.fromJSON(json);
